import {useFormContext} from "react-hook-form";
import {SingleValue} from "react-select";

import {SelectField, SelectFieldBaseProps} from "@/components/form/fields/SelectField/SelectField.tsx";
import {ThirdPartySubComponentSelect} from "@/components/thirdPartySubComponentSelect/ThirdPartySubComponentSelect.tsx";
import {ThirdPartyComponent} from "@/lib/queries/checks.ts";

interface ThirdPartySubComponentSelectFieldProps extends Omit<SelectFieldBaseProps, "name"> {
  prepend: (value: ThirdPartyComponent) => void;
  onChange?: (value: SingleValue<ThirdPartyComponent>) => void;
  groupFieldName: string;
  componentsFieldName: string;
  componentIndex: number;
}

export const ThirdPartySubComponentSelectField = ({
  groupFieldName,
  componentsFieldName,
  componentIndex,
  onChange,
  prepend,
  ...rest
}: ThirdPartySubComponentSelectFieldProps) => {
  const {watch} = useFormContext();
  const group = watch(groupFieldName);
  const componentFieldName = `${componentsFieldName}.${componentIndex}`;
  const componentTitle = watch(`${componentFieldName}.title`);
  const subComponentFieldName = `${componentFieldName}.sub_components`;
  const subcomponents: ThirdPartyComponent[] = watch(subComponentFieldName) || [];

  return (
    <SelectField
      name={subComponentFieldName}
      {...rest}
      select={
        <ThirdPartySubComponentSelect
          value={null}
          group={group}
          title={componentTitle}
          excludeIds={subcomponents.map(({id}) => id)}
          onChange={(value) => {
            if (value && !subcomponents.some(({id}) => id === value.id)) {
              prepend(value);
              onChange?.(value);
            }
          }}
        />
      }
    />
  );
};
